function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTopView = function SvgTopView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25774"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25773"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18517",
    d: "M22.209 23.876A10.667 10.667 0 0 1 7.124 8.791a7.535 7.535 0 0 0 3.543 3.543c0-2.667.667-6.667 3.981-9.333 2.685 2.667 5.472 3.7 7.56 5.791a10.666 10.666 0 0 1 0 15.085z",
    transform: "translate(4.001 4)",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18518",
    d: "M10.172 17.828A4 4 0 1 0 13.02 11l-1.353 4H9a3.983 3.983 0 0 0 1.172 2.828z",
    transform: "translate(5.668 6.667)",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }))));
};

export default SvgTopView;